import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'
import DonationsLegacyRoute from './Donations/DonationsPage/DonationsLegacyRoute'

const FundraisingContainer = lazy(
  () => import('./FundraisingContainer/FundraisingContainer')
)
const SavedFundersPageContainer = lazy(
  () => import('./SavedFundersPage/SavedFundersPageContainer')
)

const FunderProfilePage = lazy(
  () => import('./FunderFinderPage/FunderProfile/FunderProfilePage')
)

const FunderFinderPageContainer = lazy(
  () => import('./FunderFinderPage/FunderFinderPageContainer')
)

// New
const DonationsRoot = lazy(() => import('./DonationsRoot/DonationsRoot'))

export default {
  path: '/fundraising',
  exact: false,
  Component: WithPermission(FundraisingContainer, ['page:fundraising'], true),
  access: 'USER',
  routes: [
    {
      path: '/fundraising/funderfinder',
      exact: true,
      Component: FunderFinderPageContainer,
      access: 'USER',
    },
    {
      path: '/fundraising/savedfunders',
      exact: true,
      Component: SavedFundersPageContainer,
      access: 'USER',
    },
    {
      path: `/fundraising/funderfinder/:tab`,
      exact: true,
      Component: FunderFinderPageContainer,
      access: 'USER',
    },
    {
      path: `/fundraising/funder`,
      exact: true,
      Component: FunderProfilePage,
      access: 'USER',
    },
    {
      path: '/fundraising/donations/transactions',
      exact: true,
      Component: DonationsRoot,
      access: 'USER',
    },
    {
      path: '/fundraising/donations/campaigns',
      exact: true,
      Component: DonationsRoot,
      access: 'USER',
    },
    {
      path: '/fundraising/donations/payouts',
      exact: true,
      Component: DonationsRoot,
      access: 'USER',
    },
    // Legacy Routes in case users have saved them
    {
      path: '/fundraising/donations',
      exact: true,
      Component: DonationsLegacyRoute,
      access: 'USER',
    },
    {
      path: '/fundraising/payouts',
      exact: true,
      Component: DonationsLegacyRoute,
      access: 'USER',
    },
  ],
}
